import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';
import { CreateCommentDto, GetCommentsDto } from 'admiral-core';

export class CommentApi {
  static async create(dto: CreateCommentDto) {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/comment/create`,
      data: dto,
    });
  }

  static async get(dto: GetCommentsDto) {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/comment/get`,
      data: dto,
    });
  }

  static async delete(id: string) {
    return AdmiralApi.apiCall({
      method: 'DELETE',
      url: `${BASE_URL}/comment/${id}`,
    });
  }
}
